
import { Component, Vue, Prop } from 'vue-property-decorator';
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import { checklistInfoType } from '@/types/Common';

@Component({
    components:{
        CheckBox
    }
})
export default class StndChecklist extends Vue {

    @Prop({required: true})
    checklistInfo!: checklistInfoType;

}
